/**
 * i18n: ES / EN / CA translations
 */
export const LANGUAGES = [
    { code: "es", label: "ESP", name: "Español" },
    { code: "en", label: "ENG", name: "English" },
    { code: "ca", label: "CAT", name: "Català" },
];

export const translations = {
    es: {
        nav: {
            features: "Funcionalidades",
            pricing: "Precios",
            login: "Iniciar sesión",
            signup: "Registrarse",
            dashboard: "Panel",
            practice: "Practicar",
            team: "Equipo",
            settings: "Ajustes",
            leaderboard: "Clasificación",
            logout: "Cerrar sesión",
            tokens: "fichas",
            daily_uses: "usos diarios",
            daily_uses_hint: "Sesiones iniciadas hoy, sobre el máximo diario.",
        },
        hero: {
            badge: "VENCE EL PÁNICO ESCÉNICO CON IA",
            title_a: "Domina el arte de",
            title_b: "hablar en público.",
            subtitle:
                "Vence el pánico escénico practicando debates, entrevistas y discursos con una IA que te escucha, responde y mide tu persuasión en tiempo real.",
            cta_primary: "Empezar gratis",
            cta_secondary: "Ver planes",
            stat_minutes: "MIN / SESIÓN",
            stat_languages: "ES · EN · CA",
            stat_video: "VIDEO AL SERVIDOR",
        },
        features: {
            title: "Diseñado para oradores serios",
            f1_title: "Conversación en tiempo real",
            f1_desc:
                "Habla con un coach IA que se adapta a debates, entrevistas, ventas o audiencias hostiles.",
            f2_title: "Análisis de muletillas",
            f2_desc:
                "Detectamos automáticamente 'eh', 'pues', 'o sea' y más en español, inglés y catalán.",
            f3_title: "Lectura postural con MediaPipe",
            f3_desc:
                "Procesamos tu cámara en el navegador: contacto visual, parpadeo y rigidez. Nada de video al servidor.",
            f4_title: "Puntuación y reporte",
            f4_desc:
                "Score de persuasión, claridad y confianza al terminar cada sesión de 20 minutos.",
        },
        pricing: {
            title: "Elige tu plan",
            subtitle: "1 ficha = 1 sesión de 20 minutos con la IA. Suscripción mensual, cancela cuando quieras.",
            month: "/mes",
            tokens_month: "fichas al mes",
            unlimited: "fichas ilimitadas",
            choose: "Elegir plan",
            current: "Plan actual",
            most_popular: "MÁS POPULAR",
            basic_desc: "Para empezar a practicar con métricas estándar.",
            pro_desc: "Para profesionales que quieren ir más lejos.",
            studio_desc: "Para equipos y agencias. Fichas ilimitadas y hasta 10 miembros invitados.",
            features: {
                std_metrics: "Métricas estándar de oratoria",
                voice_tone: "Análisis avanzado de tono",
                hostile: "Simulación de audiencias hostiles",
                history: "Reportes históricos completos",
                team: "Cuenta multi-usuario (10 invitados)",
                admin: "Panel de administración del equipo",
                priority: "Soporte prioritario",
            },
        },
        auth: {
            login_title: "Bienvenido de nuevo",
            login_sub: "Inicia sesión para continuar tu entrenamiento.",
            register_title: "Crea tu cuenta",
            register_sub:
                "Empieza con 3 fichas de cortesía. Sin tarjeta de crédito.",
            email: "Email",
            password: "Contraseña",
            name: "Nombre",
            login_btn: "Iniciar sesión",
            register_btn: "Crear cuenta",
            no_account: "¿No tienes cuenta?",
            has_account: "¿Ya tienes cuenta?",
            error_credentials: "Email o contraseña incorrectos.",
            forgot_password: "¿Olvidaste tu contraseña?",
            forgot_title: "Recupera tu cuenta",
            forgot_sub: "Escribe tu email y te enviaremos un enlace para restablecer tu contraseña.",
            forgot_btn: "Enviar enlace",
            forgot_sent: "Si ese email está registrado, te hemos enviado un enlace para restablecer tu contraseña. Revisa tu bandeja de entrada.",
            back_to_login: "← Volver a iniciar sesión",
            or: "o",
            reset_title: "Nueva contraseña",
            reset_sub: "Elige una contraseña nueva para tu cuenta.",
            new_password: "Contraseña nueva",
            confirm_password: "Confirmar contraseña",
            reset_btn: "Guardar contraseña",
            reset_success: "Contraseña actualizada. Ya puedes iniciar sesión.",
            reset_invalid: "Este enlace no es válido o ha caducado.",
            password_too_short: "La contraseña debe tener al menos 8 caracteres.",
            password_mismatch: "Las contraseñas no coinciden.",
        },
        dash: {
            welcome: "Hola,",
            tokens_left: "FICHAS DISPONIBLES",
            sessions_done: "SESIONES",
            avg_score: "SCORE PROMEDIO",
            plan: "PLAN",
            start_session: "Iniciar nueva sesión",
            history: "Historial de sesiones",
            no_sessions: "Aún no tienes sesiones. Pulsa arriba para empezar.",
            view: "Ver",
            upgrade_cta:
                "¿Sin fichas? Sube de plan para seguir entrenando con la IA.",
            progress_title: "Tu progreso",
        },
        practice: {
            choose_scenario: "Elige tu escenario",
            upgrade_required: "Requiere plan superior",
            scenario_locked: "Tu plan no incluye este escenario. Sube de plan para desbloquearlo.",
            scenarios: {
                debate: "Debate formal",
                interview: "Entrevista de trabajo",
                sales: "Pitch de ventas",
                speech: "Discurso libre",
                hostile: "Audiencia hostil",
            },
            scenarios_desc: {
                debate:
                    "Una IA debate contigo y plantea contraargumentos sólidos.",
                interview:
                    "Un entrevistador hace preguntas exigentes pero justas.",
                sales: "Vende tu producto a un cliente escéptico.",
                speech: "Practica tu discurso y recibe feedback de un coach.",
                hostile: "Audiencia desafiante que cuestiona todo.",
            },
            language: "Idioma de la sesión",
            start: "Iniciar sesión (1 ficha)",
            mic_off: "Activar micrófono",
            mic_on: "Detener micrófono",
            hold_to_talk: "Mantén pulsado para hablar",
            recording_release: "Suelta para enviar",
            transcribing: "Transcribiendo...",
            whisper_fallback_notice: "Tu navegador no soporta dictado en vivo. Usa 'Mantén pulsado para hablar'.",
            whisper_error: "No se pudo transcribir el audio. Inténtalo de nuevo.",
            mic_denied: "Permiso de micrófono denegado.",
            mp_loading: "Cargando el modelo de seguimiento facial/postural...",
            mp_load_error: "No se pudo cargar el seguimiento en este dispositivo. La sesión sigue funcionando sin métricas de postura.",
            cam_off: "Activar cámara",
            cam_on: "Detener cámara",
            speak_now: "Habla ahora...",
            ai_speaking: "La IA está respondiendo...",
            end_session: "Finalizar sesión",
            time_left: "TIEMPO RESTANTE",
            transcript: "Transcripción en vivo",
            warn_2min:
                "¡Atención! Quedan menos de 2 minutos antes del corte automático.",
            extend_cta: "+5 minutos por 1 ficha",
            extend_success: "Sesión ampliada 5 minutos más.",
            extend_no_tokens: "No te quedan fichas para ampliar la sesión.",
            session_expired:
                "La sesión finalizó automáticamente al alcanzar 20:00.",
            tracking: {
                eye: "CONTACTO VISUAL",
                blink: "PARPADEO",
                rigidity: "RIGIDEZ",
            },
            coach: {
                label: "COACH DE POSTURA",
                too_stiff: "Te ves muy rígido/a. Mueve un poco las manos al hablar.",
                too_much_movement: "Te mueves demasiado, intenta estabilizarte.",
                low_eye_contact: "Mejora tu contacto visual con la cámara.",
                arms_not_visible: "Asegúrate de que tus brazos sean visibles en el encuadre.",
                nervous_blink: "Pareces nervioso/a, respira y relaja la mirada.",
                good: "Buena postura, sigue así.",
            },
        },
        report: {
            title: "Reporte de sesión",
            scenario: "Escenario",
            duration: "Duración",
            overall: "Score general",
            persuasion: "Persuasión",
            clarity: "Claridad",
            confidence: "Confianza",
            expressiveness: "Expresividad",
            fillers: "Muletillas detectadas",
            none: "Ninguna detectada. ¡Excelente!",
            transcript: "Transcripción completa",
            advice_title: "Consejos para mejorar",
            back: "Volver al panel",
        },
        team: {
            title: "Tu equipo",
            owner: "Propietario",
            members: "Miembros",
            invite_placeholder: "email@ejemplo.com",
            invite: "Invitar",
            pool: "Fichas del equipo",
            remove: "Quitar",
            studio_only:
                "El panel de equipo solo está disponible en el plan Estudio.",
            max_5: "Hasta 10 miembros invitados.",
            invite_link_title: "O invita con un enlace",
            invite_link_copy: "Copiar enlace",
            invite_link_copied: "¡Enlace copiado!",
        },
        join_team: {
            invites_you: "te invita a unirte a su equipo Studio en Vivoz.",
            checking: "Comprobando invitación...",
            joining: "Uniéndote al equipo...",
            success: "¡Listo! Ya formas parte del equipo.",
            go_team: "Ir a mi equipo",
            invalid: "Este enlace de invitación no es válido o ha caducado.",
            login_cta: "Iniciar sesión",
            register_cta: "Crear cuenta",
        },
        referral: {
            headline: "Invita a un amigo y recibís 2 fichas cada uno",
            sub: "Comparte tu enlace. En cuanto se registre, ganáis 2 fichas los dos.",
            cta: "Compartir enlace",
            copy: "Copiar enlace",
            link_copied: "¡Enlace copiado!",
            count_prefix: "Amigos invitados:",
            landing_invites_you: "Te han invitado a probar Vivoz. Regístrate y ganáis 2 fichas gratis cada uno.",
            checking: "Comprobando enlace...",
            redeeming: "Aplicando tu bono...",
            success: "¡Bono aplicado! Habéis ganado 2 fichas cada uno.",
            invalid: "Este enlace de invitación no es válido o ya lo has usado.",
            login_cta: "Iniciar sesión",
            register_cta: "Crear cuenta",
            go_dashboard: "Ir a mi panel",
        },
        admin: {
            title: "Panel de administración",
            users: "Usuarios",
            sessions: "Sesiones",
            revenue: "Ingresos",
            paid: "Compras",
            by_plan: "Usuarios por plan",
            recent_sessions: "Sesiones recientes",
            recent_users: "Usuarios recientes",
            avg_score: "SCORE PROMEDIO",
            teams_title: "Equipos Studio",
            team_owner: "Propietario",
            invited_accounts: "Cuentas invitadas",
            team_avg_score: "Score promedio del equipo",
            no_teams: "Todavía no hay equipos Studio.",
            search_placeholder: "Buscar por email o nombre...",
            no_results: "No hay usuarios que coincidan con la búsqueda.",
            tokens_placeholder: "Cant.",
            tokens_add: "Añadir",
            tokens_invalid: "Escribe una cantidad distinta de cero.",
            tokens_added: "Fichas actualizadas.",
        },
        settings: {
            title: "Ajustes",
            account_identity: "Tu cuenta",
            name_label: "Nombre",
            name_hint: "Este es el nombre que ven otros usuarios en la clasificación y en tu equipo.",
            leaderboard_privacy: "Privacidad de la clasificación",
            leaderboard_opt_in_desc: "Aparecer en la clasificación pública con tu nombre y puntuación. Puedes desactivarlo cuando quieras.",
            ai_identity: "Identidad de la IA",
            ai_name_label: "Nombre de la IA en el chat",
            ai_name_placeholder: "ej. Miguel",
            ai_name_hint: "Este nombre sustituirá a \"IA\" en la transcripción durante tus sesiones de práctica.",
            save: "Guardar cambios",
            saved: "Ajustes guardados.",
            billing_title: "Facturación",
            sub_active_desc: "Tu suscripción se renueva automáticamente el",
            sub_cancelled_desc: "Tu suscripción se cancelará al final del periodo actual, el",
            cancel_sub: "Cancelar suscripción",
            sub_cancel_success: "Suscripción cancelada. Seguirás teniendo acceso hasta el final del periodo pagado.",
            no_active_sub: "No se encontró ninguna suscripción activa.",
        },
        achievements: {
            title: "Logros",
            unlocked: "Conseguido",
            locked: "Por conseguir",
            reward: "ficha de regalo",
            rewards: "fichas de regalo",
            toast_title: "¡Logro desbloqueado!",
        },
        leaderboard: {
            title: "Clasificación",
            weekly: "Semanal",
            monthly: "Mensual",
            by_score: "Por puntuación",
            by_sessions: "Por sesiones",
            you: "TÚ",
            empty: "Todavía no hay datos suficientes para la clasificación.",
            prizes_title: "Premios del mes",
            prizes_hint: "Los 3 primeros del ranking mensual por puntuación se llevan fichas de regalo automáticamente al cerrar el mes.",
            prev_winners_title: "Ganadores del mes pasado",
            credits: "fichas",
        },
        onboarding: {
            step1_title: "Bienvenido a Vivoz",
            step1_body: "Practica debates, entrevistas, ventas y discursos frente a una IA que reacciona de verdad. Cada sesión dura hasta 20 minutos y consume 1 ficha.",
            step2_title: "Activa cámara y micrófono",
            step2_body: "La cámara se enciende sola para que te veas mientras hablas, y un coach de postura te avisa en vivo si te mueves de más o tus brazos salen del encuadre.",
            step3_title: "Gana fichas mientras mejoras",
            step3_body: "Cada sesión te da una puntuación de claridad, confianza y persuasión. Sube en la clasificación semanal y mensual, y desbloquea logros que regalan fichas extra.",
            step4_title: "Apareces en la clasificación pública",
            step4_body: "Por defecto, tu nombre y puntuación son visibles para el resto de usuarios en la clasificación. Puedes desactivarlo cuando quieras desde Ajustes.",
            skip: "Saltar",
            next: "Siguiente",
            start: "Empezar",
        },
        consent: {
            title: "Antes de activar tu cámara",
            body: "Vivoz usa tu cámara y micrófono para darte feedback en tiempo real sobre tu oratoria. El vídeo se analiza en tu propio navegador — no se graba ni se almacena.",
            point_video: "El vídeo se procesa localmente para medir contacto visual y postura. No guardamos grabaciones.",
            point_audio: "El audio se transcribe a texto para generar el feedback de la IA.",
            accept: "Acepto y continúo",
            decline: "Continuar sin cámara",
        },
        terms_gate: {
            title: "Términos y Privacidad",
            body: "Antes de continuar, revisa y acepta nuestros",
            and: "y nuestra",
            terms_link: "Términos de Servicio",
            privacy_link: "Política de Privacidad",
            accept: "Acepto los términos",
            decline: "Rechazar y cerrar sesión",
        },
        notfound: {
            title: "404",
            body: "Esta página no existe o se ha movido.",
            cta: "Volver al inicio",
        },
        common: {
            loading: "Cargando...",
            cancel: "Cancelar",
            save: "Guardar",
            error: "Ha ocurrido un error.",
            close: "Cerrar",
            try_again: "Reintentar",
        },
    },
    en: {
        nav: {
            features: "Features",
            pricing: "Pricing",
            login: "Log in",
            signup: "Sign up",
            dashboard: "Dashboard",
            practice: "Practice",
            team: "Team",
            settings: "Settings",
            leaderboard: "Leaderboard",
            logout: "Log out",
            tokens: "tokens",
            daily_uses: "daily uses",
            daily_uses_hint: "Sessions started today, out of the daily max.",
        },
        hero: {
            badge: "AI PUBLIC SPEAKING PLATFORM",
            title_a: "Master the art of",
            title_b: "speaking in public.",
            subtitle:
                "Practice debates, interviews and speeches with an AI that listens, replies and measures your persuasion in real time.",
            cta_primary: "Start free",
            cta_secondary: "See plans",
            stat_minutes: "MIN / SESSION",
            stat_languages: "ES · EN · CA",
            stat_video: "VIDEO TO SERVER",
        },
        features: {
            title: "Built for serious speakers",
            f1_title: "Real-time conversation",
            f1_desc:
                "Talk to an AI coach that adapts to debates, interviews, sales or hostile audiences.",
            f2_title: "Filler word analysis",
            f2_desc:
                "We auto-detect 'um', 'like', 'you know' in English, Spanish and Catalan.",
            f3_title: "MediaPipe posture reading",
            f3_desc:
                "Camera processed locally in your browser: eye contact, blinking, rigidity. No raw video uploaded.",
            f4_title: "Score & report",
            f4_desc:
                "Persuasion, clarity and confidence scores after every 20-minute session.",
        },
        pricing: {
            title: "Choose your plan",
            subtitle: "1 token = 1 conversation of up to 20 minutes. Monthly subscription, cancel anytime.",
            month: "/mo",
            tokens_month: "tokens per month",
            unlimited: "unlimited tokens",
            choose: "Choose plan",
            current: "Current plan",
            most_popular: "MOST POPULAR",
            basic_desc: "Start practising with the standard metrics.",
            pro_desc: "For professionals who want to push further.",
            studio_desc: "For teams and agencies. Unlimited tokens and up to 10 invited members.",
            features: {
                std_metrics: "Standard speaking metrics",
                voice_tone: "Advanced tone analysis",
                hostile: "Hostile audience simulation",
                history: "Full historical reports",
                team: "Multi-user account (10 invited)",
                admin: "Team admin dashboard",
                priority: "Priority support",
            },
        },
        auth: {
            login_title: "Welcome back",
            login_sub: "Log in to continue training.",
            register_title: "Create your account",
            register_sub:
                "Start with 3 free tokens. No credit card required.",
            email: "Email",
            password: "Password",
            name: "Name",
            login_btn: "Log in",
            register_btn: "Create account",
            no_account: "Don't have an account?",
            has_account: "Already have an account?",
            error_credentials: "Wrong email or password.",
            forgot_password: "Forgot your password?",
            forgot_title: "Recover your account",
            forgot_sub: "Enter your email and we'll send you a link to reset your password.",
            forgot_btn: "Send link",
            forgot_sent: "If that email is registered, we've sent you a password reset link. Check your inbox.",
            back_to_login: "← Back to login",
            or: "or",
            reset_title: "New password",
            reset_sub: "Choose a new password for your account.",
            new_password: "New password",
            confirm_password: "Confirm password",
            reset_btn: "Save password",
            reset_success: "Password updated. You can log in now.",
            reset_invalid: "This link is invalid or has expired.",
            password_too_short: "Password must be at least 8 characters.",
            password_mismatch: "Passwords don't match.",
        },
        dash: {
            welcome: "Hi,",
            tokens_left: "TOKENS AVAILABLE",
            sessions_done: "SESSIONS",
            avg_score: "AVG SCORE",
            plan: "PLAN",
            start_session: "Start a new session",
            history: "Session history",
            no_sessions: "You don't have sessions yet. Tap above to start.",
            view: "View",
            upgrade_cta:
                "Out of tokens? Upgrade your plan to keep training.",
            progress_title: "Your progress",
        },
        practice: {
            choose_scenario: "Choose your scenario",
            upgrade_required: "Requires a higher plan",
            scenario_locked: "Your plan doesn't include this scenario. Upgrade to unlock it.",
            scenarios: {
                debate: "Formal debate",
                interview: "Job interview",
                sales: "Sales pitch",
                speech: "Open speech",
                hostile: "Hostile audience",
            },
            scenarios_desc: {
                debate:
                    "An AI debates with you and brings strong counterarguments.",
                interview:
                    "An interviewer asks challenging but fair questions.",
                sales: "Sell your product to a skeptical customer.",
                speech: "Deliver your speech and get coach feedback.",
                hostile: "A challenging audience questioning everything.",
            },
            language: "Session language",
            start: "Start session (1 token)",
            mic_off: "Activate mic",
            mic_on: "Stop mic",
            hold_to_talk: "Hold to talk",
            recording_release: "Release to send",
            transcribing: "Transcribing...",
            whisper_fallback_notice: "Your browser doesn't support live dictation. Use 'Hold to talk' instead.",
            whisper_error: "Couldn't transcribe the audio. Please try again.",
            mic_denied: "Microphone permission denied.",
            mp_loading: "Loading the face/posture tracking model...",
            mp_load_error: "Couldn't load tracking on this device. The session still works without posture metrics.",
            cam_off: "Activate camera",
            cam_on: "Stop camera",
            speak_now: "Speak now...",
            ai_speaking: "AI is responding...",
            end_session: "End session",
            time_left: "TIME LEFT",
            transcript: "Live transcript",
            warn_2min:
                "Heads up! Less than 2 minutes before the automatic cut-off.",
            extend_cta: "+5 more minutes for 1 token",
            extend_success: "Session extended by 5 minutes.",
            extend_no_tokens: "You have no tokens left to extend the session.",
            session_expired:
                "The session ended automatically at 20:00.",
            tracking: {
                eye: "EYE CONTACT",
                blink: "BLINK",
                rigidity: "RIGIDITY",
            },
            coach: {
                label: "POSTURE COACH",
                too_stiff: "You look very stiff. Move your hands a little as you speak.",
                too_much_movement: "You're moving too much, try to settle down.",
                low_eye_contact: "Improve your eye contact with the camera.",
                arms_not_visible: "Make sure your arms are visible in the frame.",
                nervous_blink: "You seem nervous, breathe and relax your gaze.",
                good: "Good posture, keep it up.",
            },
        },
        report: {
            title: "Session report",
            scenario: "Scenario",
            duration: "Duration",
            overall: "Overall score",
            persuasion: "Persuasion",
            clarity: "Clarity",
            confidence: "Confidence",
            expressiveness: "Expressiveness",
            fillers: "Filler words detected",
            none: "None detected. Excellent!",
            transcript: "Full transcript",
            advice_title: "Tips to improve",
            back: "Back to dashboard",
        },
        team: {
            title: "Your team",
            owner: "Owner",
            members: "Members",
            invite_placeholder: "email@example.com",
            invite: "Invite",
            pool: "Team token pool",
            remove: "Remove",
            studio_only:
                "Team panel is only available on the Studio plan.",
            max_5: "Up to 10 invited members.",
            invite_link_title: "Or invite with a link",
            invite_link_copy: "Copy link",
            invite_link_copied: "Link copied!",
        },
        join_team: {
            invites_you: "invites you to join their Studio team on Vivoz.",
            checking: "Checking invite...",
            joining: "Joining the team...",
            success: "Done! You're now part of the team.",
            go_team: "Go to my team",
            invalid: "This invite link is invalid or has expired.",
            login_cta: "Log in",
            register_cta: "Create account",
        },
        referral: {
            headline: "Invite a friend and you both get 2 tokens",
            sub: "Share your link. As soon as they sign up, you both get 2 tokens.",
            cta: "Share link",
            copy: "Copy link",
            link_copied: "Link copied!",
            count_prefix: "Friends invited:",
            landing_invites_you: "You've been invited to try Vivoz. Sign up and you both get 2 free tokens.",
            checking: "Checking link...",
            redeeming: "Applying your bonus...",
            success: "Bonus applied! You both got 2 tokens.",
            invalid: "This invite link is invalid or you've already used it.",
            login_cta: "Log in",
            register_cta: "Create account",
            go_dashboard: "Go to my dashboard",
        },
        admin: {
            title: "Admin panel",
            users: "Users",
            sessions: "Sessions",
            revenue: "Revenue",
            paid: "Purchases",
            by_plan: "Users by plan",
            recent_sessions: "Recent sessions",
            recent_users: "Recent users",
            avg_score: "AVG SCORE",
            teams_title: "Studio teams",
            team_owner: "Owner",
            invited_accounts: "Invited accounts",
            team_avg_score: "Team average score",
            no_teams: "No Studio teams yet.",
            search_placeholder: "Search by email or name...",
            no_results: "No users match your search.",
            tokens_placeholder: "Amt.",
            tokens_add: "Add",
            tokens_invalid: "Enter a non-zero amount.",
            tokens_added: "Tokens updated.",
        },
        settings: {
            title: "Settings",
            account_identity: "Your account",
            name_label: "Name",
            name_hint: "This is the name other users see on the leaderboard and in your team.",
            leaderboard_privacy: "Leaderboard privacy",
            leaderboard_opt_in_desc: "Show up on the public leaderboard with your name and score. You can turn this off anytime.",
            ai_identity: "AI identity",
            ai_name_label: "AI name in chat",
            ai_name_placeholder: "e.g. Michael",
            ai_name_hint: "This name replaces \"AI\" in the transcript during your practice sessions.",
            save: "Save changes",
            saved: "Settings saved.",
            billing_title: "Billing",
            sub_active_desc: "Your subscription renews automatically on",
            sub_cancelled_desc: "Your subscription will cancel at the end of the current period, on",
            cancel_sub: "Cancel subscription",
            sub_cancel_success: "Subscription cancelled. You'll keep access until the end of the paid period.",
            no_active_sub: "No active subscription found.",
        },
        achievements: {
            title: "Achievements",
            unlocked: "Unlocked",
            locked: "To unlock",
            reward: "bonus token",
            rewards: "bonus tokens",
            toast_title: "Achievement unlocked!",
        },
        leaderboard: {
            title: "Leaderboard",
            weekly: "Weekly",
            monthly: "Monthly",
            by_score: "By score",
            by_sessions: "By sessions",
            you: "YOU",
            empty: "Not enough data for a leaderboard yet.",
            prizes_title: "Monthly prizes",
            prizes_hint: "The top 3 of the monthly score ranking automatically get bonus tokens when the month closes.",
            prev_winners_title: "Last month's winners",
            credits: "tokens",
        },
        onboarding: {
            step1_title: "Welcome to Vivoz",
            step1_body: "Practice debates, interviews, sales pitches and speeches against an AI that actually reacts. Each session runs up to 20 minutes and costs 1 token.",
            step2_title: "Turn on camera and mic",
            step2_body: "The camera switches on automatically so you can see yourself while you speak, and a posture coach warns you live if you're moving too much or your arms leave the frame.",
            step3_title: "Earn tokens as you improve",
            step3_body: "Every session scores your clarity, confidence and persuasion. Climb the weekly and monthly leaderboard, and unlock achievements that give bonus tokens.",
            step4_title: "You're visible on the public leaderboard",
            step4_body: "By default, your name and score are visible to other users on the leaderboard. You can turn this off anytime in Settings.",
            skip: "Skip",
            next: "Next",
            start: "Get started",
        },
        consent: {
            title: "Before we turn on your camera",
            body: "Vivoz uses your camera and microphone to give you real-time feedback on your speaking. Video is analyzed locally in your browser — it isn't recorded or stored.",
            point_video: "Video is processed locally to measure eye contact and posture. We don't save recordings.",
            point_audio: "Audio is transcribed to text to generate the AI's feedback.",
            accept: "Accept and continue",
            decline: "Continue without camera",
        },
        terms_gate: {
            title: "Terms & Privacy",
            body: "Before continuing, please review and accept our",
            and: "and our",
            terms_link: "Terms of Service",
            privacy_link: "Privacy Policy",
            accept: "I accept the terms",
            decline: "Decline and log out",
        },
        notfound: {
            title: "404",
            body: "This page doesn't exist or has moved.",
            cta: "Back to home",
        },
        common: {
            loading: "Loading...",
            cancel: "Cancel",
            save: "Save",
            error: "Something went wrong.",
            close: "Close",
            try_again: "Retry",
        },
    },
    ca: {
        nav: {
            features: "Funcionalitats",
            pricing: "Preus",
            login: "Inicia sessió",
            signup: "Registra't",
            dashboard: "Panell",
            practice: "Practicar",
            team: "Equip",
            settings: "Ajustos",
            leaderboard: "Classificació",
            logout: "Tanca sessió",
            tokens: "fitxes",
            daily_uses: "usos diaris",
            daily_uses_hint: "Sessions iniciades avui, sobre el màxim diari.",
        },
        hero: {
            badge: "PLATAFORMA D'ORATÒRIA AMB IA",
            title_a: "Domina l'art de",
            title_b: "parlar en públic.",
            subtitle:
                "Practica debats, entrevistes i discursos amb una IA que escolta, respon i mesura la teva persuasió en temps real.",
            cta_primary: "Comença gratis",
            cta_secondary: "Veure plans",
            stat_minutes: "MIN / SESSIÓ",
            stat_languages: "ES · EN · CA",
            stat_video: "VÍDEO AL SERVIDOR",
        },
        features: {
            title: "Dissenyat per a oradors seriosos",
            f1_title: "Conversa en temps real",
            f1_desc:
                "Parla amb un coach IA que s'adapta a debats, entrevistes, vendes o audiències hostils.",
            f2_title: "Anàlisi de crosses",
            f2_desc:
                "Detectem automàticament 'eh', 'doncs', 'o sigui' en català, castellà i anglès.",
            f3_title: "Lectura postural amb MediaPipe",
            f3_desc:
                "Processem la càmera al navegador: contacte visual, parpelleig i rigidesa. Cap vídeo al servidor.",
            f4_title: "Puntuació i informe",
            f4_desc:
                "Score de persuasió, claredat i confiança en acabar cada sessió de 20 minuts.",
        },
        pricing: {
            title: "Tria el teu pla",
            subtitle: "1 fitxa = 1 sessió de 20 minuts amb la IA. Subscripció mensual, cancel·la quan vulguis.",
            month: "/mes",
            tokens_month: "fitxes al mes",
            unlimited: "fitxes il·limitades",
            choose: "Tria pla",
            current: "Pla actual",
            most_popular: "MÉS POPULAR",
            basic_desc: "Per començar a practicar amb mètriques estàndard.",
            pro_desc: "Per a professionals que volen anar més enllà.",
            studio_desc:
                "Per a equips i agències. Fitxes il·limitades i fins a 10 membres convidats.",
            features: {
                std_metrics: "Mètriques estàndard d'oratòria",
                voice_tone: "Anàlisi avançada de to",
                hostile: "Simulació d'audiències hostils",
                history: "Informes històrics complets",
                team: "Compte multi-usuari (10 convidats)",
                admin: "Panell d'administració d'equip",
                priority: "Suport prioritari",
            },
        },
        auth: {
            login_title: "Benvingut de nou",
            login_sub: "Inicia sessió per continuar l'entrenament.",
            register_title: "Crea el teu compte",
            register_sub:
                "Comença amb 3 fitxes de cortesia. Sense targeta.",
            email: "Correu",
            password: "Contrasenya",
            name: "Nom",
            login_btn: "Inicia sessió",
            register_btn: "Crear compte",
            no_account: "No tens compte?",
            has_account: "Ja tens compte?",
            error_credentials: "Correu o contrasenya incorrectes.",
            forgot_password: "Has oblidat la contrasenya?",
            forgot_title: "Recupera el teu compte",
            forgot_sub: "Escriu el teu email i t'enviarem un enllaç per restablir la contrasenya.",
            forgot_btn: "Enviar enllaç",
            forgot_sent: "Si aquest email està registrat, t'hem enviat un enllaç per restablir la contrasenya. Revisa la teva safata d'entrada.",
            back_to_login: "← Tornar a iniciar sessió",
            or: "o",
            reset_title: "Nova contrasenya",
            reset_sub: "Tria una contrasenya nova per al teu compte.",
            new_password: "Contrasenya nova",
            confirm_password: "Confirmar contrasenya",
            reset_btn: "Desar contrasenya",
            reset_success: "Contrasenya actualitzada. Ja pots iniciar sessió.",
            reset_invalid: "Aquest enllaç no és vàlid o ha caducat.",
            password_too_short: "La contrasenya ha de tenir almenys 8 caràcters.",
            password_mismatch: "Les contrasenyes no coincideixen.",
        },
        dash: {
            welcome: "Hola,",
            tokens_left: "FITXES DISPONIBLES",
            sessions_done: "SESSIONS",
            avg_score: "SCORE MITJÀ",
            plan: "PLA",
            start_session: "Iniciar nova sessió",
            history: "Historial de sessions",
            no_sessions:
                "Encara no tens sessions. Prem a dalt per començar.",
            view: "Veure",
            upgrade_cta:
                "Sense fitxes? Puja de pla per continuar entrenant.",
            progress_title: "El teu progrés",
        },
        practice: {
            choose_scenario: "Tria el teu escenari",
            upgrade_required: "Requereix un pla superior",
            scenario_locked: "El teu pla no inclou aquest escenari. Puja de pla per desbloquejar-lo.",
            scenarios: {
                debate: "Debat formal",
                interview: "Entrevista de feina",
                sales: "Pitch de vendes",
                speech: "Discurs lliure",
                hostile: "Audiència hostil",
            },
            scenarios_desc: {
                debate:
                    "Una IA debat amb tu i planteja contraarguments sòlids.",
                interview:
                    "Un entrevistador fa preguntes exigents però justes.",
                sales: "Ven el teu producte a un client escèptic.",
                speech:
                    "Practica el teu discurs i rep feedback d'un coach.",
                hostile:
                    "Una audiència desafiant que qüestiona tot.",
            },
            language: "Idioma de la sessió",
            start: "Iniciar sessió (1 fitxa)",
            mic_off: "Activar micròfon",
            mic_on: "Aturar micròfon",
            hold_to_talk: "Mantén premut per parlar",
            recording_release: "Deixa anar per enviar",
            transcribing: "Transcrivint...",
            whisper_fallback_notice: "El teu navegador no admet dictat en directe. Fes servir 'Mantén premut per parlar'.",
            whisper_error: "No s'ha pogut transcriure l'àudio. Torna-ho a provar.",
            mic_denied: "Permís de micròfon denegat.",
            mp_loading: "Carregant el model de seguiment facial/postural...",
            mp_load_error: "No s'ha pogut carregar el seguiment en aquest dispositiu. La sessió continua funcionant sense mètriques de postura.",
            cam_off: "Activar càmera",
            cam_on: "Aturar càmera",
            speak_now: "Parla ara...",
            ai_speaking: "La IA està responent...",
            end_session: "Finalitzar sessió",
            time_left: "TEMPS RESTANT",
            transcript: "Transcripció en directe",
            warn_2min:
                "Atenció! Falten menys de 2 minuts abans del tall automàtic.",
            extend_cta: "+5 minuts més per 1 fitxa",
            extend_success: "Sessió ampliada 5 minuts més.",
            extend_no_tokens: "No et queden fitxes per ampliar la sessió.",
            session_expired:
                "La sessió ha finalitzat automàticament a les 20:00.",
            tracking: {
                eye: "CONTACTE VISUAL",
                blink: "PARPELLEIG",
                rigidity: "RIGIDESA",
            },
            coach: {
                label: "COACH DE POSTURA",
                too_stiff: "Et veus molt rígid/a. Mou una mica les mans en parlar.",
                too_much_movement: "Et mous massa, intenta estabilitzar-te.",
                low_eye_contact: "Millora el teu contacte visual amb la càmera.",
                arms_not_visible: "Assegura't que els teus braços siguin visibles a l'enquadrament.",
                nervous_blink: "Sembles nerviós/osa, respira i relaxa la mirada.",
                good: "Bona postura, continua així.",
            },
        },
        report: {
            title: "Informe de sessió",
            scenario: "Escenari",
            duration: "Durada",
            overall: "Score general",
            persuasion: "Persuasió",
            clarity: "Claredat",
            confidence: "Confiança",
            expressiveness: "Expressivitat",
            fillers: "Crosses detectades",
            none: "Cap detectada. Excel·lent!",
            transcript: "Transcripció completa",
            advice_title: "Consells per millorar",
            back: "Tornar al panell",
        },
        team: {
            title: "El teu equip",
            owner: "Propietari",
            members: "Membres",
            invite_placeholder: "correu@exemple.com",
            invite: "Convidar",
            pool: "Fitxes de l'equip",
            remove: "Treure",
            studio_only:
                "El panell d'equip només està disponible al pla Estudi.",
            max_5: "Fins a 10 membres convidats.",
            invite_link_title: "O convida amb un enllaç",
            invite_link_copy: "Copiar enllaç",
            invite_link_copied: "Enllaç copiat!",
        },
        join_team: {
            invites_you: "et convida a unir-te al seu equip Studio a Vivoz.",
            checking: "Comprovant invitació...",
            joining: "Unint-te a l'equip...",
            success: "Fet! Ja formes part de l'equip.",
            go_team: "Anar al meu equip",
            invalid: "Aquest enllaç d'invitació no és vàlid o ha caducat.",
            login_cta: "Iniciar sessió",
            register_cta: "Crear compte",
        },
        referral: {
            headline: "Convida un amic i guanyeu 2 fitxes cadascú",
            sub: "Comparteix el teu enllaç. Quan es registri, guanyeu 2 fitxes els dos.",
            cta: "Compartir enllaç",
            copy: "Copiar enllaç",
            link_copied: "Enllaç copiat!",
            count_prefix: "Amics convidats:",
            landing_invites_you: "T'han convidat a provar Vivoz. Registra't i guanyeu 2 fitxes gratis cadascú.",
            checking: "Comprovant enllaç...",
            redeeming: "Aplicant el teu bo...",
            success: "Bo aplicat! Heu guanyat 2 fitxes cadascú.",
            invalid: "Aquest enllaç d'invitació no és vàlid o ja l'has fet servir.",
            login_cta: "Iniciar sessió",
            register_cta: "Crear compte",
            go_dashboard: "Anar al meu panell",
        },
        admin: {
            title: "Panell d'administració",
            users: "Usuaris",
            sessions: "Sessions",
            revenue: "Ingressos",
            paid: "Compres",
            by_plan: "Usuaris per pla",
            recent_sessions: "Sessions recents",
            recent_users: "Usuaris recents",
            avg_score: "SCORE MITJÀ",
            teams_title: "Equips Studio",
            team_owner: "Propietari",
            invited_accounts: "Comptes convidats",
            team_avg_score: "Score mitjà de l'equip",
            no_teams: "Encara no hi ha equips Studio.",
            search_placeholder: "Cerca per email o nom...",
            no_results: "Cap usuari coincideix amb la cerca.",
            tokens_placeholder: "Qtat.",
            tokens_add: "Afegir",
            tokens_invalid: "Escriu una quantitat diferent de zero.",
            tokens_added: "Fitxes actualitzades.",
        },
        settings: {
            title: "Ajustos",
            account_identity: "El teu compte",
            name_label: "Nom",
            name_hint: "Aquest és el nom que veuen altres usuaris a la classificació i al teu equip.",
            leaderboard_privacy: "Privacitat de la classificació",
            leaderboard_opt_in_desc: "Aparèixer a la classificació pública amb el teu nom i puntuació. Ho pots desactivar quan vulguis.",
            ai_identity: "Identitat de la IA",
            ai_name_label: "Nom de la IA al xat",
            ai_name_placeholder: "p. ex. Miquel",
            ai_name_hint: "Aquest nom substituirà \"IA\" a la transcripció durant les teves sessions de pràctica.",
            save: "Desar canvis",
            saved: "Ajustos desats.",
            billing_title: "Facturació",
            sub_active_desc: "La teva subscripció es renova automàticament el",
            sub_cancelled_desc: "La teva subscripció es cancel·larà al final del periode actual, el",
            cancel_sub: "Cancel·lar subscripció",
            sub_cancel_success: "Subscripció cancel·lada. Mantindràs l'accés fins al final del periode pagat.",
            no_active_sub: "No s'ha trobat cap subscripció activa.",
        },
        achievements: {
            title: "Assoliments",
            unlocked: "Aconseguit",
            locked: "Per aconseguir",
            reward: "fitxa de regal",
            rewards: "fitxes de regal",
            toast_title: "Assoliment desbloquejat!",
        },
        leaderboard: {
            title: "Classificació",
            weekly: "Setmanal",
            monthly: "Mensual",
            by_score: "Per puntuació",
            by_sessions: "Per sessions",
            you: "TU",
            empty: "Encara no hi ha prou dades per a la classificació.",
            prizes_title: "Premis del mes",
            prizes_hint: "Els 3 primers del rànquing mensual per puntuació s'emporten fitxes de regal automàticament en tancar el mes.",
            prev_winners_title: "Guanyadors del mes passat",
            credits: "fitxes",
        },
        onboarding: {
            step1_title: "Benvingut a Vivoz",
            step1_body: "Practica debats, entrevistes, vendes i discursos davant d'una IA que reacciona de veritat. Cada sessió dura fins a 20 minuts i consumeix 1 fitxa.",
            step2_title: "Activa càmera i micròfon",
            step2_body: "La càmera s'engega sola perquè et vegis mentre parles, i un coach de postura t'avisa en directe si et mous massa o els teus braços surten de l'enquadrament.",
            step3_title: "Guanya fitxes mentre millores",
            step3_body: "Cada sessió et dona una puntuació de claredat, confiança i persuasió. Puja a la classificació setmanal i mensual, i desbloqueja assoliments que regalen fitxes extra.",
            step4_title: "Apareixes a la classificació pública",
            step4_body: "Per defecte, el teu nom i puntuació són visibles per a la resta d'usuaris a la classificació. Ho pots desactivar quan vulguis des d'Ajustos.",
            skip: "Ometre",
            next: "Següent",
            start: "Començar",
        },
        consent: {
            title: "Abans d'activar la teva càmera",
            body: "Vivoz utilitza la teva càmera i micròfon per donar-te feedback en temps real sobre la teva oratòria. El vídeo s'analitza al teu propi navegador — no es grava ni s'emmagatzema.",
            point_video: "El vídeo es processa localment per mesurar contacte visual i postura. No guardem gravacions.",
            point_audio: "L'àudio es transcriu a text per generar el feedback de la IA.",
            accept: "Accepto i continuo",
            decline: "Continuar sense càmera",
        },
        terms_gate: {
            title: "Termes i Privacitat",
            body: "Abans de continuar, revisa i accepta els nostres",
            and: "i la nostra",
            terms_link: "Termes de Servei",
            privacy_link: "Política de Privacitat",
            accept: "Accepto els termes",
            decline: "Rebutjar i tancar sessió",
        },
        notfound: {
            title: "404",
            body: "Aquesta pàgina no existeix o s'ha mogut.",
            cta: "Tornar a l'inici",
        },
        common: {
            loading: "Carregant...",
            cancel: "Cancel·lar",
            save: "Desar",
            error: "Hi ha hagut un error.",
            close: "Tancar",
            try_again: "Reintentar",
        },
    },
};

export function t(lang, path) {
    const parts = path.split(".");
    let cur = translations[lang] || translations.es;
    for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) cur = cur[p];
        else return path;
    }
    return cur;
}
